import React from "react";
import styled, { css } from "styled-components";
import { FROSTED_BLACK } from "../../config";

const Container = styled.div<{ multiple: boolean }>`
  display: flex;
  flex-direction: column;

  h5 {
    margin: 0;
    margin-bottom: 8px;
  }

  div {
    font-size: 14px;

    ${({ multiple }) =>
    multiple
      ? css`
            & > div {
              display: flex;
              background-color: ${FROSTED_BLACK};
              display: inline-block;
              padding: 4px 12px;
              border-radius: 20px;
              font-size: 13px;
              margin-right: 8px;
              transition: 0.2s ease;
              overflow: hidden;
              text-overflow: ellipsis;
              max-height: 16px;
              white-space: nowrap;
              max-width: calc(100% - 1rem - 20px);
              position: relative;
            }
          `
      : css`
            line-height: 25px;
          `}
  }
`;

interface ReadOnlyFieldProps {
  label?: string;
  content?: JSX.Element | JSX.Element[] | string | string[];
  multiple?: boolean;
}

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
  label,
  content,
  multiple = false,
}: ReadOnlyFieldProps) => (
  <Container multiple={multiple} className="read-only-field">
    {label ? <h5>{label}</h5> : null}
    {content ? <div>{content}</div> : null}
  </Container>
);
